(() => {
  let active = null;
  let frame = 0;
  const position = () => {
    frame = 0;
    if (!active || !active.isConnected) return;
    const tip = active.querySelector('.sb-field-help__tip');
    if (!tip) return;
    const width = document.documentElement.clientWidth;
    const height = window.innerHeight;
    const trigger = active.getBoundingClientRect();
    const box = tip.getBoundingClientRect();
    const left = width <= 640 ? (width - box.width) / 2 : Math.max(16, Math.min(trigger.right - box.width, width - box.width - 16));
    const above = trigger.top - box.height - 12;
    const top = above >= 16 ? above : Math.min(trigger.bottom + 12, height - box.height - 16);
    active.style.setProperty('--sb-tip-left', `${Math.max(16, left)}px`);
    active.style.setProperty('--sb-tip-top', `${Math.max(16, top)}px`);
  };
  const close = () => {
    if (!active) return;
    active.removeAttribute('data-sb-help-open');
    active.setAttribute('data-sb-help-dismissed', '');
    active = null;
  };
  const open = (help) => {
    if (!help?.querySelector('.sb-field-help__tip')) return;
    if (active !== help) close();
    active = help;
    help.removeAttribute('data-sb-help-dismissed');
    help.setAttribute('data-sb-help-open', '');
    position();
  };
  document.addEventListener('focusin', (event) => open(event.target.closest('.sb-field-help')));
  document.addEventListener('focusout', (event) => { if (active?.contains(event.target) && !active.contains(event.relatedTarget)) close(); });
  document.addEventListener('mouseover', (event) => { const help = event.target.closest('.sb-field-help'); if (help && !help.contains(event.relatedTarget)) open(help); });
  document.addEventListener('mouseout', (event) => { if (active?.contains(event.target) && !active.contains(event.relatedTarget) && !active.contains(document.activeElement)) close(); });
  document.addEventListener('click', (event) => {
    const help = event.target.closest('.sb-field-help');
    if (help) {
      // A help control inside a label must not also activate its form field.
      event.preventDefault();
      help.focus({ preventScroll: true });
      open(help);
    } else close();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') close();
    const help = event.target.closest('.sb-field-help');
    if (help && (event.key === 'Enter' || event.key === ' ')) { event.preventDefault(); open(help); }
  });
  const schedule = () => { if (active && !frame) frame = requestAnimationFrame(position); };
  document.addEventListener('scroll', schedule, { passive: true, capture: true });
  window.addEventListener('resize', schedule, { passive: true });
})();
